// extracted by mini-css-extract-plugin
export var footer = "_m3-5";
export var fulfillmentInput = "_m3-0";
export var shipDateInput = "_m3-1";
export var shipmentModal = "_m3-2";
export var shipmentModalContent = "_m3-3";
export var tableContainer = "_m3-4";